module.exports = __webpack_public_path__ + "fonts/cf3864c96864e42aa3effb51b7750974.svg";